import React, { FC, useEffect, useState } from 'react';

import { BluePrintsRead } from '@ariksa/compliance-policies/api';
import { each } from 'lodash';
import { useSelector } from 'react-redux';

import { ViolationsByAccountsComponent } from 'containers/Compliance/Components/ComplianceDashboard/ViolationsByAccountsComponent';
import { selectBlueprints } from 'containers/PolicyHub/Blueprints/selectors';
import { selectSharedState } from 'containers/SharedState/selectors';

export const ViolationsByAccounts: FC = () => {
  const { violationsByAccount } = useSelector(selectBlueprints);
  const { blueprints } = useSelector(selectSharedState);
  const [data, setData] = useState<Record<string, BluePrintsRead>>();

  useEffect(() => {
    let items: Record<string, BluePrintsRead> = {};
    each(blueprints.data, o => (items[o?.id] = o));
    setData(items);
  }, [blueprints.data]);

  return (
    <ViolationsByAccountsComponent
      label="Policy Violations by Accounts"
      violationsByAccount={{
        data: violationsByAccount.data,
        isLoading: violationsByAccount.isLoading,
      }}
      blueprints={{ data: data || {}, isLoading: blueprints.isLoading }}
      innerRadius="84%"
      outerRadius="94%"
      cx="47%"
      legendsW="40%"
    />
  );
};
